module.exports = __webpack_public_path__ + "img/chevron-right.fa19fd03.svg";